<template>
  <svg
    v-if="mapSVG"
    :viewBox="mapSVG.viewBox"
    class="svg-map mx-auto mb-3"
    xmlns="http://www.w3.org/2000/svg"
  >
    <map-path
      v-for="path in mapSVG.paths"
      :key="path.id"
      :path="path"
    />
  </svg>
</template>

<script>
import axios from 'axios'
export default {
  name: 'MapSvg',
  components: {
    MapPath: () => import('@/components/Map/MapPath')
  },
  props: {
    paths: {
      type: String,
      required: true
    }
  },
  data: function () {
    return {
      mapSVG: null
    }
  },
  created () {
    axios
      .get(this.paths)
      .then(response => (this.mapSVG = response.data))
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="sass">
.svg-map
  max-height: 400px
  display: block
  fill: transparent
  stroke: black

</style>
